import { get_axios_instance, api_variables, errorHandler } from '@/apis/variables.js';
import Vue from 'vue';

var axios_instance = get_axios_instance(api_variables.SERVICE_LEVELS);
var axios_instance_upload_template = get_axios_instance(api_variables.SERVICE_LEVELS_UPLOAD_TEMPLATE);

const _pk_name = "id";

const state = {
    entityWiseData: {},
    isFetching: false,
    isSaving: false,
    isDeleting: false,
    editMode: false,
    record: {}
};

const getters = {
    editMode: (state) => {
        return state.editMode;
    },
    record: (state) => {
        return state.record
    }
}

const mutations = {
    set: (state, [payload, id]) => {
        Vue.set(state.entityWiseData, id, payload);
    },

    addEntity: (state, [payload, id]) => {
        state.entityWiseData[id].push(payload);
    },

    updateEntityById: (state, [payload, id]) => {
        for (let i = 0; i < state.entityWiseData[id].length; i++) {
            if (state.entityWiseData[id][i][_pk_name] === payload.id) {
                state.entityWiseData[id].splice(i, 1, payload);
            }
        }
    },

    removeEntityById: (state, [payload, id]) => {
        for (let i = 0; i < state.entityWiseData[id].length; i++) {
            if (state.entityWiseData[id][i][_pk_name] == payload) {
                state.entityWiseData[id].splice(i, 1);
            }
        }
    },

    setFetching: (state, payload) => {
        state.isFetching = payload;
    },

    setSaving: (state, payload) => {
        state.isSaving = payload;
    },

    setDeleting: (state, payload) => {
        state.isDeleting = payload;
    },
    setEditMode: (state, payload) => {
        state.editMode = payload.editMode;
        state.record = payload.record;
    }
}

const actions = {
    async fetchAll({ commit }, payload) {
       
        try {
            commit("setFetching", true);
            let res = await axios_instance.get(`/`, {
                params: {
                    le_id: payload
                }
            });
            commit("setFetching", false);
            if (res.status == 200) {
                commit("set", [res.data.payload.data, payload]);
            }
            return res;
        } catch (err) {
            throw errorHandler(err.response);
        }
    },

    async uploadTemplate({ commit }, payload) {
        try {
            commit("setFetching", true);
            let res = await axios_instance_upload_template.post(``, payload);
            commit("setFetching", false);
            return res;
        } catch (err) {
            throw errorHandler(err.response);
        }
    },

    async create({ commit }, payload) {
        try {
            commit("setSaving", true);
            let res = await axios_instance.post("/", payload);
            commit("setSaving", false);
            if (res.status == 201) {
                commit("addEntity", [res.data.payload, payload.data.le_id]);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async update({ commit }, [payload, id]) {
        try {
            commit("setSaving", true);
            let res = await axios_instance.put(`/${payload.data.id}`, payload);
            commit("setSaving", false);
            if (res.status == 200) {
                commit("updateEntityById", [res.data.payload, id]);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async delete({ commit }, [payload, id]) {
        try {
            commit("setDeleting", true);
            let res = await axios_instance.delete(`/${payload}`);
            commit("setDeleting", false);
            if (res.status == 200) {
                commit("removeEntityById", [payload, id]);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async changeEditMode({ commit }, payload) {
        
        try {
            commit("setEditMode", payload);
        } catch (error) {
            throw errorHandler(error.response);
        }
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};